module.exports = __webpack_public_path__ + "img/profile03.b172bddf.jpg";